import { DefinedValue, RealDefinedValue } from "@Alternatives/Model";
import { ICommandBase } from "@Quest/cqrs";

export class DeleteCorporateAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.DeleteCorporateAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Validate: boolean;

	constructor(workspaceId: number, strategyId: string, attributeId: number, validate: boolean)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();
		this.Validate = validate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.DeleteCorporateAttributeCommandV1, TCh.Domain.Quest';
	}
}


export class RenameCorporateAttributesSectionCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.RenameCorporateAttributesSectionCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	OldName: string;
	NewName: string;

	constructor(workspaceId: number, strategyId: string, oldName: string, newName: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = "0";
		this.OldName = oldName;
		this.NewName = newName;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.RenameCorporateAttributesSectionCommandV1, TCh.Domain.Quest';
	}
}

export class CreateCorporateNumericAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.CreateCorporateNumericAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinValue: number | null;
	MaxValue: number | null;
	Script: string | null;
	DefinedValues: RealDefinedValue[] | null;

	constructor(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: number | null, maxValue: number | null, script: string | null, definedValues: RealDefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinValue = minValue;
		this.MaxValue = maxValue;
		this.Script = script;
		this.DefinedValues = definedValues;		
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.CreateCorporateNumericAttributeCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateCorporateNumericAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.UpdateCorporateNumericAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinValue: number | null;
	MaxValue: number | null;
	Script: string | null;
	DefinedValues: RealDefinedValue[] | null;

	constructor(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: number | null, maxValue: number | null, script: string | null, definedValues: RealDefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinValue = minValue;
		this.MaxValue = maxValue;
		this.Script = script;
		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.UpdateCorporateNumericAttributeCommandV1, TCh.Domain.Quest';
	}
}


export class CreateCorporateDateAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.CreateCorporateDateAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinValue: Date | null;
	MaxValue: Date | null;
	DefinedValues: DefinedValue[] | null;

	constructor(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: Date | null, maxValue: Date | null, definedValues: DefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinValue = minValue;
		this.MaxValue = maxValue;
		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.CreateCorporateDateAttributeCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateCorporateDateAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.UpdateCorporateDateAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinValue: Date | null;
	MaxValue: Date | null;
	DefinedValues: DefinedValue[] | null;

	constructor(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: Date | null, maxValue: Date | null, definedValues: DefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinValue = minValue;
		this.MaxValue = maxValue;
		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.UpdateCorporateDateAttributeCommandV1, TCh.Domain.Quest';
	}
}


export class CreateCorporateEmailAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.CreateCorporateEmailAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	DefinedValues: DefinedValue[] | null;

	constructor(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string,
		allowMultipleValues: boolean, definedValues: DefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.CreateCorporateEmailAttributeCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateCorporateEmailAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.UpdateCorporateEmailAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	DefinedValues: DefinedValue[] | null;

	constructor(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string,
		allowMultipleValues: boolean, definedValues: DefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.UpdateCorporateEmailAttributeCommandV1, TCh.Domain.Quest';
	}
}


export class CreateCorporateTextAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.CreateCorporateTextAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinLength: number | null;
	MaxLength: number | null;
	DefinedValues: DefinedValue[] | null;

	constructor(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minLength: number | null, maxLength: number | null, definedValues: DefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinLength = minLength;
		this.MaxLength = maxLength;
		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.CreateCorporateTextAttributeCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateCorporateTextAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.UpdateCorporateTextAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinLength: number | null;
	MaxLength: number | null;
	DefinedValues: DefinedValue[] | null;

	constructor(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minLength: number | null, maxLength: number | null, definedValues: DefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinLength = minLength;
		this.MaxLength = maxLength;
		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.UpdateCorporateTextAttributeCommandV1, TCh.Domain.Quest';
	}
}


export class CreateCorporateMultilineAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.CreateCorporateMultilineAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	Name: string;
	Description: string;
	Section: string;

	Rows: number;
	MinLength: number | null;
	MaxLength: number | null;

	constructor(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, rows: number,
		minLength: number | null, maxLength: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;

		this.Rows = rows;
		this.MinLength = minLength;
		this.MaxLength = maxLength;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.CreateCorporateMultilineAttributeCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateCorporateMultilineAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateAttributes.Commands.UpdateCorporateMultilineAttributeCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	Name: string;
	Description: string;
	Section: string;

	Rows: number;
	MinLength: number | null;
	MaxLength: number | null;

	constructor(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, rows: number,
		minLength: number | null, maxLength: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;

		this.Rows = rows;
		this.MinLength = minLength;
		this.MaxLength = maxLength;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateAttributes.Commands.UpdateCorporateMultilineAttributeCommandV1, TCh.Domain.Quest';
	}
}